import { EventEmitter } from '@angular/core';
import { OnnaReportResponse } from '../../../../../models/oona-post';
import { ReportSectionEnum } from '../../../../../models/measure/report';
import { PdfExportService } from '../../../../services/export-pdf/pdf-export.service';
import { CommonConstant } from '../../../../app.constants';
var OonaReportComponent = /** @class */ (function () {
    function OonaReportComponent(pdfService) {
        this.pdfService = pdfService;
        this.numOfItemPerPage = CommonConstant.MAX_ITEM_PER_PAGE_REPORT;
        this.changePage = new EventEmitter();
        this.currentPage = 1;
    }
    OonaReportComponent.prototype.ngOnInit = function () {
    };
    OonaReportComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.data.data.length === 0) {
            this.pdfService.incrementNumberReportReady("" + OonaReportComponent.COMPONENT_NAME + this.pageIndex);
            return;
        }
        this.pdfService.imagedLoadedTrigger.subscribe(function (data) {
            if (data.component === "" + OonaReportComponent.COMPONENT_NAME + _this.pageIndex && data.currentCounter === _this.data.data.length) {
                _this.pdfService.incrementNumberReportReady("" + OonaReportComponent.COMPONENT_NAME + _this.pageIndex);
            }
        });
    };
    Object.defineProperty(OonaReportComponent.prototype, "maxPage", {
        get: function () {
            if (!this.data || !this.data.totalCount) {
                return 0;
            }
            var totalFullPage = Math.floor(this.data.totalCount / this.numOfItemPerPage);
            var hasPartialPage = (this.data.totalCount % this.numOfItemPerPage) > 0;
            return hasPartialPage ? totalFullPage + 1 : totalFullPage;
        },
        enumerable: true,
        configurable: true
    });
    OonaReportComponent.prototype.onChangePage = function (evt) {
        var _this = this;
        this.changePage.emit({
            reportSection: ReportSectionEnum.OONA_REPORT,
            criteriaChange: { page_no: evt }
        });
        // deplay for rendering
        setTimeout(function () {
            _this.currentPage = evt;
        }, 200);
    };
    Object.defineProperty(OonaReportComponent.prototype, "isExportingPdfReport", {
        get: function () {
            return this.pdfService.exportingPdf;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OonaReportComponent.prototype, "haveNoData", {
        get: function () {
            return this.data && (!this.data.data || this.data.data.length === 0);
        },
        enumerable: true,
        configurable: true
    });
    OonaReportComponent.COMPONENT_NAME = 'OonaReportComponent';
    OonaReportComponent.MAX_POST_PER_PAGE = 9;
    return OonaReportComponent;
}());
export { OonaReportComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/oona-report/oona-report.component.ts.pre-build-optimizer.js